import { clsx } from '~/styles/utils';

import { dotStyle, smallStyle } from './BrandDot.css';

type Props = {
  color: string;
  small?: boolean;
};

export const BrandDot = ({ color, small = false }: Props) => {
  return <span className={clsx(dotStyle, small && smallStyle)} style={{ background: color }} />;
};
